import { Attr, BelongsTo, Model } from "spraypaint";

import type Organisation from "shared/resources/Organisation";
import type User from "shared/resources/User";
import { ApplicationRecord } from "shared/services/spraypaint";

import type AIFeatureConfiguration from "./AIFeatureConfiguration";

@Model()
class AIFeedback extends ApplicationRecord {
  static apiNamespace = "/ai";

  static jsonapiType = "feedbacks";

  @BelongsTo() aiFeatureConfiguration: AIFeatureConfiguration;

  @Attr() aiFeatureConfigurationId: number;

  @Attr() archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() generatedResult: Record<string, unknown>;

  @Attr() input: Record<string, unknown>;

  @BelongsTo() organisation: Organisation;

  @Attr() source: string;

  @Attr() thumbsDownReason: string;

  @Attr() thumbsUp: string;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;
}

export default AIFeedback;
